import React from 'react'
import Hero from './Hero';
import Navbar from '../Navbar';
import Footer from '../footer';
import Feature from './Feature';
import Menu from './menu';

const index = () => {
  return (
    <div className='bg-white'>
        <Navbar/>
        <Hero/>
        <Feature/>
        <Menu />
        <Footer/>
    </div>
  )
}

export default index;